/**
 * bookingsrv API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PartnerMyBookingSearchRequest { 
    bookingDateFrom?: string;
    bookingDateTo?: string;
    bookingNumber?: string;
    pnr?: string;
    statuses?: Array<string>;
    supplierType?: PartnerMyBookingSearchRequest.SupplierTypeEnum;
}
export namespace PartnerMyBookingSearchRequest {
    export const SupplierTypeEnum = {
        Air: 'AIR',
        Hotel: 'HOTEL',
        Combo: 'COMBO',
        Tours: 'TOURS',
        Train: 'TRAIN',
        Ship: 'SHIP',
        Other: 'OTHER'
    } as const;
    export type SupplierTypeEnum = typeof SupplierTypeEnum[keyof typeof SupplierTypeEnum];
}


